import Vue from 'vue'
import index from '@/api/index'
export default ({ $axios, redirect, store, error }, inject) => {
  // 基本配置
  $axios.defaults.timeout = 40000
  // 配置基础接口域名
  // $axios.defaults.baseURL = process.env.BASE_URL
  // console.log($axios)
  // $axios.defaults.baseURL = '/api'
  // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  // $axios.defaults.headers = {'Content-Type': 'application/json;charset=UTF-8'}
  //  $axios.defaults.transformRequest = [function (data) {
  //   // 将参数对象转成JSON形式
  //   data = JSON.stringify(data)
  //   return data
  // }]
  // 请求拦截器
  $axios.onRequest(config => {
    // console.log(config, 'configconfig')
    // store.commit('system/toggleLoading', true)
    // console.log(store.state.system.userToken)
    if (store.state.system.userToken) {
      config.headers.Authorization = 'bearer ' + store.state.system.userToken
    }
    return config
  })

  // 响应拦截器
  $axios.onResponse(res => {
    if (res.status === 200) {
      //       if (res.data.code === 3) {

      //       } else if (res.data.code === 3) {
      // Vue.prototype.$tips({ msg: 'Login status has expired' })
      //         store.dispatch('system/logOut')
      //       }
      // Vue.prototype.$loading()
      // if (process.client) {
      //   Vue.prototype.$loading().close()
      // }
      // if (res.config.url === 'https://api.ipify.org?format=json') {
      if (res.config.url === 'https://ipapi.co/ip') {
        return Promise.resolve(res.data)
      }
      if (res.data.code === 3) {
        if (process.client) {
          Vue.prototype.$tips({ msg: 'Login status has expired.' })
        }
        store.dispatch('system/logOut')
      } else if (res.data.code !== 200) {
        if (process.client) {
          Vue.prototype.$tips({ msg: res.data.msg })
        }
      }
      return Promise.resolve(res.data)
    }
  })
  $axios.onError(errorRes => {
    const code = parseInt(errorRes.response && errorRes.response.status)
    if (code === 404 || code === 500 || code === 504) {
      error({ statusCode: code })
    }

    return Promise.reject(errorRes)
  })
  inject('api', index($axios))
}
